import Vue from 'vue'
import VueRouter from 'vue-router'
import { i18n, vantLocales } from '@/lang'
vantLocales(i18n.locale)
Vue.use(VueRouter)
const routes = [
  {
    path: '/',
    redirect: '/reservationLogin',
    component: () => import('@/views/reservationLogin.vue'),
    meta: { title: 'message.BIKE_RESERVATION' }

  },
  {
    path: '/reservationLogin',
    name: 'ReservationLogin',
    component: () => import('@/views/reservationLogin.vue'),
    meta: { title: 'message.BIKE_RESERVATION' }
  },
  {
    path: '/resultSuccess',
    name: 'ResultSuccess',
    component: () => import('@/views/resultSuccess.vue'),
    meta: { title: 'message.BIKE_RESERVATION' }

  },
  {
    path: '/failedOne',
    name: 'FailedOne',
    component: () => import('@/views/failedOne.vue'),
    meta: { title: 'message.BIKE_RESERVATION' }

  },
  {
    path: '/failedTwo',
    name: 'FailedTwo',
    component: () => import('@/views/failedTwo.vue'),
    meta: { title: 'message.BIKE_RESERVATION' }

  },
  {
    path: '/failedThree',
    name: 'FailedThree',
    component: () => import('@/views/failedThree.vue'),
    meta: { title: 'message.BIKE_RESERVATION' }

  },
  {
    path: '/failedFour',
    name: 'FailedFour',
    component: () => import('@/views/failedFour.vue'),
    meta: { title: 'message.BIKE_RESERVATION' }
  },
  // sg bike
  {
    path: '/sgbike',
    name: 'sgbike',
    component: () => import('@/views/sgbike.vue'),
    meta: { title: 'Anywheel & SG Bike' }
  },
  {
    path: '/sgbikeWeb',
    name: 'sgbikeWeb',
    component: () => import('@/views/sgbikeWeb.vue'),
    meta: { title: 'Anywheel & SG Bike' }
  },
  // 2024年度总结
  {
    path: '/twfthJourney',
    name: 'twfthJourney',
    component: () => import('@/views/twfthJourney.vue'),
    meta: { title: 'Anywheel' }
  },
  {
    path: '/powerbank',
    name: 'powerBank',
    component: () => import('@/views/powerBank.vue'),
    meta: { title: 'PowerUp With Anywheel' }
  },
  // 到骑行详情页面
  {
    path: '/exploreRouteDetails',
    name: 'exploreRouteDetails',
    component: () => import('@/views/exploreRouteDetails.vue'),
    meta: { title: 'Route Details' }
  },
  // 车辆广告推广页
  {
    path: '/group/:groupId',
    name: 'group',
    component: () => import('@/views/group.vue'),
    props: true, // 开启 props 传参，方便组件内获取参数
    meta: { title: 'Partner with Anywheel' }
  },
  // merch页面外部
  {
    path: '/inwarmregard',
    name: 'inwarmregard',
    component: () => import('@/views/inwarmregards.vue'),
    props: true, // 开启 props 传参，方便组件内获取参数
    meta: { title: 'Anywheel' }
  },
  // 内部
  {
    path: '/inwarmregardshop',
    name: 'inwarmregard',
    component: () => import('@/views/inwarmregardshop.vue'),
    props: true, // 开启 props 传参，方便组件内获取参数
    meta: { title: 'Anywheel' }
  },
  {
    path: '/yuu/UserAgreement',
    component: () => import('@/views/reviseApp/userAgreement.vue'),
    name: 'userAgreement',
    meta: { title: 'User Agreement' }
  },
  {
    path: '/yuu/ServiceAgreement',
    name: 'serviceAgreement',
    component: () => import('@/views/reviseApp/serviceAgreement.vue'),
    meta: { title: 'Service Agreement' }
  },
  {
    path: '/parkingBays',
    name: 'parkingBays',
    component: () => import('@/views/parkingBays.vue'),
    meta: {
      title: 'Parking Bays'
    }
  },
  {
    path: '/ihqTalkPage',
    name: 'ihqTalkPage',
    component: () => import('@/views/partnerPage/ihqTalkPage.vue'),
    meta: {
      title: 'FREE Iced Kopi / Teh (S)'
    }
  }

]
const router = new VueRouter({
  mode: 'history',
  base: '/colink/',
  routes
})
// 统一配标题
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = i18n.t(to.meta.title)
    console.log(i18n, 'Vue.i18n')
    console.log('document.title', document.title)
  }
  next()
})

export default router
